module.exports = __webpack_public_path__ + "img/btk.84b1269f.png";